import { useReferral } from "../hooks/useReferral";
import { Gift, Copy, ExternalLink, Users, DollarSign, TrendingUp, Star } from "lucide-react";
import { toast } from "sonner";
import { Link } from "react-router-dom";

import { useTranslation } from 'react-i18next';
export default function ReferralWidget() {
  const { t } = useTranslation();
  const { referralLink, referralCode, stats, tierInfo, copyLink, shareWhatsApp, shareTelegram } = useReferral();

  const handleCopy = () => {
    copyLink();
    toast.success("Referral link copied!", {
      description: "Share it with friends to earn rewards.",
    });
  };

  return (
    <div className="border border-amber-500/30 bg-gradient-to-br from-amber-500/5 to-transparent p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Gift className="w-4 h-4 text-amber-400" />
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-400">{t('referral_widget.referral_program')}</span>
        </div>
        <div className="flex items-center gap-1 px-2 py-0.5 border border-zinc-700">
          <Star className="w-3 h-3 text-amber-400" />
          <span className="font-mono text-[9px] text-zinc-400 uppercase">{tierInfo.current}</span>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 mb-3">
        <div className="text-center p-2 bg-zinc-950/40 border border-zinc-800">
          <div className="font-display text-lg text-amber-400">${stats.credits}</div>
          <div className="font-mono text-[8px] uppercase tracking-wider text-zinc-600">Credits</div>
        </div>
        <div className="text-center p-2 bg-zinc-950/40 border border-zinc-800">
          <div className="font-display text-lg text-white">{stats.convertedCount}</div>
          <div className="font-mono text-[8px] uppercase tracking-wider text-zinc-600">Referred</div>
        </div>
        <div className="text-center p-2 bg-zinc-950/40 border border-zinc-800">
          <div className="font-display text-lg text-emerald-400">{stats.conversionRate}%</div>
          <div className="font-mono text-[8px] uppercase tracking-wider text-zinc-600">Rate</div>
        </div>
      </div>

      <div className="flex items-center gap-2 mb-3 p-2 bg-zinc-950/60 border border-zinc-800">
        <code className="font-mono text-[10px] text-amber-400 truncate flex-1 font-bold tracking-wider">
          {referralCode}
        </code>
        <button
          onClick={handleCopy}
          className="shrink-0 p-1.5 hover:bg-zinc-800 transition-colors"
          aria-label={t('referral_widget.copy_referral_link')}
        >
          <Copy className="w-3.5 h-3.5 text-zinc-500 hover:text-amber-400" />
        </button>
      </div>

      <div className="flex gap-2 mb-3">
        <button
          onClick={shareWhatsApp}
          className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 border border-zinc-700 hover:border-green-500/50 hover:bg-green-500/5 transition-colors font-mono text-[9px] text-zinc-400"
        >{t('referral_widget.wa')}</button>
        <button
          onClick={shareTelegram}
          className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 border border-zinc-700 hover:border-blue-500/50 hover:bg-blue-500/5 transition-colors font-mono text-[9px] text-zinc-400"
        >{t('referral_widget.tg')}</button>
        <button
          onClick={handleCopy}
          className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 border border-amber-500/30 bg-amber-500/5 hover:bg-amber-500/10 transition-colors font-mono text-[9px] text-amber-400"
        >
          <Copy className="w-3 h-3" /> Copy
        </button>
      </div>

      <div className="flex gap-2">
        <Link
          to="/referral"
          className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 bg-amber-500 text-black font-mono text-[10px] uppercase tracking-wider hover:bg-amber-400 transition-colors"
        >
          <Users className="w-3.5 h-3.5" />
          Dashboard
        </Link>
        <a
          href={referralLink}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 border border-zinc-700 hover:border-zinc-500 transition-colors"
          aria-label={t('referral_widget.open_referral_link')}
        >
          <ExternalLink className="w-3.5 h-3.5 text-zinc-400" />
        </a>
      </div>
    </div>
  );
}
